import {
  DEFAULT_CANVAS_DATABASE_HEIGHT,
  DEFAULT_CANVAS_DATABASE_WIDTH,
  MAX_CANVAS_DATABASE_HEIGHT,
  MIN_CANVAS_DATABASE_HEIGHT,
} from '@streamlain/database-identity';

export const CANVAS_DATABASE_PADDING_TOP = 0;
export const CANVAS_DATABASE_PADDING_RIGHT = 16;
export const CANVAS_DATABASE_PADDING_BOTTOM = 0;
export const CANVAS_DATABASE_PADDING_LEFT = 16;
export const CANVAS_DATABASE_VERTICAL_PADDING =
  CANVAS_DATABASE_PADDING_TOP + CANVAS_DATABASE_PADDING_BOTTOM;

export {
  DEFAULT_CANVAS_DATABASE_HEIGHT,
  DEFAULT_CANVAS_DATABASE_WIDTH,
  MAX_CANVAS_DATABASE_HEIGHT,
  MIN_CANVAS_DATABASE_HEIGHT,
};
